export default __webpack_public_path__ + "static/media/logo1.e8866c9f.jpg";